import { useNavigate, useParams } from 'react-router-dom';
import Preloader from '../../whatsapp/small_component/preloader';
import { useEffect } from 'react';
import domain from '../../reusecomponent/domain';
import { saveToken } from '../../whatsapp/function/token';
import { setAccessToken } from '../../redux/tokenslice';
import { useDispatch } from 'react-redux';
import Swalaleart from '../../whatsapp/function/swalaleart';

function AdminLogin() {
  const navigate = useNavigate();
  const { token } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchLogin() {
      try {
        const res = await fetch(`${domain()}/admin_login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });

        if (!res.ok) {
          navigate('/');
          return;
        }

        const response = await res.json();

        if (response?.status) {
          saveToken(response.data);
          dispatch(setAccessToken(response.data));

          Swalaleart({
            title: "Success",
            text: response.message,
            icon: "success",
            confirmcolor: '#1fee5b'
          });

          navigate('/client-area');
        } else {
          navigate('/');
        }
      } catch (e) {
        navigate('/');
      }
    }

    fetchLogin();
  }, [token, dispatch, navigate]);

  return (
    <div>
      <Preloader action={true} />
    </div>
  );
}

export default AdminLogin;